import React from 'react';
import { AutodeskBrandingStyled } from './LoginWrapper.styles';

export default function AutodeskBranding(): JSX.Element {
	return <AutodeskBrandingStyled />;
}
